import { useContext } from "react";
import { Bell } from "lucide-react";

import { Badge } from "@/modern/components/ui/badge";
import { Button } from "@/modern/components/ui/button";
import { cn } from "@/modern/utils";
import BryntumContext from "@/react/context/bryntumContext";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys.jsx";

import { NOTIFICATION_BADGE_MAX } from "../constants/layout";
import { useNotificationPopupBadgeCount } from "../hooks/useNotificationPopup";

interface NotificationBellProps {
  className?: string;
}

export function NotificationBell({ className }: NotificationBellProps) {
  const badgeCount = useNotificationPopupBadgeCount();
  const { editorHandler } = useContext(BryntumContext);

  const handleOpen = () => {
    editorHandler.openEditor(EDITOR_KEYS.notificationPopup, {}, {}, {});
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={cn(
        "relative size-9 shrink-0 rounded-lg shadow-sm transition-shadow hover:shadow-md",
        className,
      )}
      aria-label={
        badgeCount > 0
          ? `${badgeCount} notifications`
          : "Notifications"
      }
      onClick={handleOpen}
    >
      <Bell className="size-[1.125rem]" />
      {badgeCount > 0 && (
        <Badge
          variant="destructive"
          className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[10px] font-semibold"
        >
          {badgeCount > NOTIFICATION_BADGE_MAX ? `${NOTIFICATION_BADGE_MAX}+` : badgeCount}
        </Badge>
      )}
    </Button>
  );
}
